import * as React from 'react';
import './App.css';

interface FooterProps {
  id?: string;
}

export class Footer extends React.Component<FooterProps, {}> {
  render() {
    return (
        <footer className="App-footer" id={this.props.id}>
         This information is not intended to diagnose, treat, cure, or
         prevent any medical condition or be a substitute for professional medical advice.
        </footer>
    );
  }
}
